import { Outlet } from 'react-router-dom';
import SmartSendNavigation from '~/apps/smartsend/components/onboarding/components/smart-send-navigation';
import { P2GIcon, SvgAddCircle, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import useSmartNav from '~/hooks/use-smart-nav';
import DesktopTitledLayout from './desktop-layout';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { routesOfOrders } from '~/routes/groups/orders';
import { Suspense } from 'react';
import { Add } from '~/apps/smartsend/components/smartsend/filter/Add';
import MobileLayout from './mobile-layout';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { currentPageRoute } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);

  if (isXs) {
    return (
      <MobileLayout>
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout
      title={t('ORDERS_AREA_TITLE', { defaultValue: 'Orders' })}
      actions={
        <Add>
          <span style={{ cursor: 'pointer' }}>
            <P2GIcon size="sm" palette="primary">
              <SvgAddCircle />
            </P2GIcon>
          </span>
        </Add>
      }
    >
      <Suspense>
        <SmartSendNavigation currentPageRoute={currentPageRoute} routes={routesOfOrders} />
      </Suspense>
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'My Orders';
